<template>
  <div
    :class="[
      'coupon-wrapper',
      { [`theme__${couponInfo.themeColor}`]: couponInfo.themeColor },
      { coupon__disabled: isExpire },
    ]"
    @click="couponClick"
  >
    <div class="coupon">
      <div class="coupon-content">
        <div
          :class="['coupon-tag', { [`coupon-tag__${couponInfo.couponTagColor}`]: couponInfo.couponTagColor }]"
          v-if="couponInfo.couponTagText"
        >
          {{ couponInfo.couponTagText }}
        </div>
        <div class="coupon-left">
          <!-- 普通券，带奖品logo -->
          <div class="prize-logo" aria-hidden="true" v-if="isDefaultCoupon">
            <img :src="couponInfo.prizeLogo" alt="prize logo(優惠券獎品logo)" />
          </div>
          <!-- 现金券，带金额 -->
          <div
            class="coupon-amount"
            v-if="isCashCoupon"
          >
            <Amount :currencyType="currencyType" :prizeAmountYuan="couponInfo.prizeAmountYuan"></Amount>
            <span class="total-amount">{{ couponInfo.pkgInfo }}</span>
          </div>
          <!-- 折扣券，带折扣 -->
          <div class="coupon-discount" v-if="isDiscountCoupon" role="text">
            <span :class="['number-box', { [`number-box__${numberFontStyle}`]: numberFontStyle }]">{{
              couponInfo.prizeDiscount
            }}</span>
            <span class="discount">{{ discountUnitWithLang }}</span>
          </div>
        </div>
        <div class="coupon-middle" role="text">
          <div class="coupon-sp-info" v-if="couponInfo.spDesc">
            <div class="sp-logo" v-if="couponInfo.spLogo" aria-hidden="true">
              <img :src="couponInfo.spLogo" :alt="couponInfo.spDesc" />
            </div>
            <div>{{ couponInfo.spDesc }}</div>
          </div>
          <div
            class="coupon-title"
            :aria-label="parseCurrencyAria(couponInfo.prizeName, true, currencyType)"
            v-html="couponInfo.prizeName"
          ></div>
          <div
            class="coupon-desc"
            :aria-label="parseCurrencyAria(couponInfo.prizeDesc, true, currencyType)"
            v-html="couponInfo.prizeDesc"
          ></div>
        </div>
        <div :class="['coupon-right', { 'stamp-width': isShowStamp }]">
          <div class="coupon-stamp" v-if="isShowStamp">
            <div class="coupon-stamp-inner">
              <div class="coupon-stamp-txt" v-html="couponInfo.stampText"></div>
            </div>
          </div>
          <div
            v-if="isShowButton"
            v-stat.click="{
              tag: 'comp-coupon-exchange.item-exchange',
              ext: { fprizeAmountYuan: couponInfo.prizeAmountYuan },
            }"
            @click.stop="handleExchange"
            :class="[
              'button',
              { [`button__${couponInfo.buttonType}`]: couponInfo.buttonType },
              { [`${enButtionStyle}`]: enButtionStyle },
            ]"
            role="button"
          >
            <img src="./assets/icon-lock.svg" class="icon-lock" v-if="isLock" alt="buton icon lock(按鈕圖標-鎖)" />
            <template v-if="!isLock">{{ couponInfo.couponBtnText }}</template>
            <slot name="coupon-btn-ui"></slot>
          </div>
        </div>
        <!-- 主題 logo -->
        <img class="coupon-theme-logo" v-if="couponInfo.themeLogo" :src="couponInfo.themeLogo" alt="" />
      </div>
      <!-- 券装饰（两个半圆+虚线） -->
      <i class="semicircle semicircle__top" :style="{ background: couponInfo.semicircleColor }"></i>
      <i class="semicircle semicircle__bottom" :style="{ background: couponInfo.semicircleColor }"></i>
      <i class="coupon-line" :style="{ background: couponInfo.semicircleColor }"></i>
    </div>

    <div class="coupon-tips-bar" role="text" v-if="isShowTips">
      <div class="tips-left">
        <!-- 提示条类型1 （手动图标） -->
        <i class="tips-icon icon-manual" v-if="isShowManualTips"></i>
        <!-- 提示条类型2 （连锁囷标） -->
        <i class="tips-icon icon-chain" v-else-if="isShowChainTips"></i>
        <!-- 提示条类型3 （银行图标） -->
        <i class="tips-icon icon-bank" v-else-if="isShowBankTips"></i>
        <template>{{ couponInfo.tipsText }}</template>
      </div>
      <div class="tips-right">{{ couponInfo.tipsTextRight }}</div>
    </div>
    <div class="coupon-chain" v-if="isChain">
      <div class="coupon-shadow-wrap">
        <div class="coupon-shadow">
          <i class="semicircle" :style="{ background: couponInfo.semicircleColor }"></i>
        </div>
      </div>
      <div class="coupon-shadow-wrap">
        <div class="coupon-shadow">
          <i class="semicircle" :style="{ background: couponInfo.semicircleColor }"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import CouponMixin from './mixin/mixin.vue';

@Component
export default class Coupon extends mixins(CouponMixin) {
}
</script>

<style lang="less" scoped>
@import './less/coupon.less';
</style>
